module.exports = __webpack_public_path__ + "static/virtualclimber.1bc08464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/virtualclimber.jpg
// module id = 118
// module chunks = 71883469174636 213534597649335